import classNames from 'classnames';
import type { JSX } from 'react';
import React from 'react';

import { CreativePreviewImage, Tooltip } from '@feathr/components';

import type { IThumbnailCarouselItem } from './ThumbnailCarousel.types';

import * as styles from './ThumbnailCarousel.css';

/* Matches --l-thumb-size in ThumbnailCarousel.css */
const THUMBNAIL_SIZE = 32;

interface IThumbnailItemProps {
  creative: IThumbnailCarouselItem;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

function ThumbnailItem({
  creative,
  isSelected,
  onSelect,
}: Readonly<IThumbnailItemProps>): JSX.Element {
  const adTagScale = creative.isAdTag
    ? THUMBNAIL_SIZE / Math.max(creative.adTagWidth ?? 300, creative.adTagHeight ?? 250)
    : undefined;

  return (
    <Tooltip className={styles.tooltipTrigger} title={creative.filename}>
      <button
        className={classNames(styles.thumbnailButton, {
          [styles.selected]: isSelected,
        })}
        data-name={`thumbnail-${creative.id}`}
        onClick={(): void => onSelect(creative.id)}
        type={'button'}
      >
        <CreativePreviewImage
          adTagHeight={creative.adTagHeight}
          adTagHtml={creative.adTagHtml}
          adTagScale={adTagScale}
          adTagWidth={creative.adTagWidth}
          alt={creative.filename}
          className={styles.thumbnailImage}
          isAdTag={creative.isAdTag}
          isVideo={creative.isVideo ?? false}
          placeholderClassName={styles.thumbnailPlaceholder}
          skeletonClassName={styles.thumbnailSkeleton}
          src={creative.thumbnailUrl}
        />
      </button>
    </Tooltip>
  );
}

export default ThumbnailItem;
